import tianqiUBT from '@/utils/tianqiUBT';
import platformApi from '@/api/platformApi.js';
import { PLATFORM_TYPE } from '@/utils/uploadImg.js';
import browserCallNative from './BrowserCallNative';
import env from '../env';
import tools from '../tools';

let __id = 0;
const __callbacks = {};
window.callBack = function callBack(data) {
  try {
    const { callbackId } = data;
    const callback = __callbacks[callbackId];
    if (callback) {
      if (data.code === 0) {
        callback.resolve(data.data);
      } else {
        const error = new Error(data.msg);
        error.response = data;
        callback.reject(error);
      }
      delete __callbacks[callbackId];
    }
  } catch (error) {
    tianqiUBT.customEvent({
      eventId: 'hitch-main-script-error-appcallback',
      callBackKeys: Object.keys(__callbacks),
      data,
      error,
    });
  }
};

function callNative(classMap, method, params) {
  return new Promise((resolve, reject) => {
    try {
      __id += 1;
      const id = __id;
      __callbacks[id] = { resolve, reject };
      const data = {
        classMap,
        method,
        params: params === null ? '' : JSON.stringify(params),
        callbackId: id.toString(),
      };
      if (process.env.NODE_ENV !== 'pro') {
        __callbacks[id].timestamp = Date.now();
        // eslint-disable-next-line no-console
        console.log(data);
      }
      const dataStr = JSON.stringify(data);
      if (env.isIOS && tools.versionCompare(env.appVersion, '3.1.4') >= 0) {
        window.webkit.messageHandlers.callNative.postMessage(dataStr);
      } else {
        window.AppFunctions.callNative(dataStr);
      }
    } catch (error) {
      tianqiUBT.customEvent({
        eventId: 'hitch-main-script-error-appcallnative',
        callBackKeys: Object.keys(__callbacks),
        classMap,
        method,
        params,
        error,
      });
    }
  });
}

export default class extends browserCallNative {
  static invalidToken() {
    let needLogin = true;
    delete this[`getTokenAndKey_Promise_${needLogin}`];
    needLogin = false;
    delete this[`getTokenAndKey_Promise_${needLogin}`];
    return callNative('User', 'invalidToken', null);
  }

  static getTokenAndKey({ needLogin }) {
    const promiseKey = `getTokenAndKey_Promise_${needLogin}`;
    let promise = this[promiseKey];
    if (promise) {
      return promise;
    }

    promise = callNative('User', 'getTokenAndKey', { needLogin });

    if (needLogin) {
      promise.then((result) => {
        let isLogin = false;
        if (result.ticket) {
          isLogin = !!(result.token && result.ticket);
        } else {
          isLogin = !!(result.token);
        }
        if (!isLogin) {
          delete this[promiseKey];
        }
      }, () => {
        delete this[promiseKey];
      });
    }
    this[promiseKey] = promise;
    return promise;
  }

  static setPageTitle({ title }) {
    return browserCallNative.callNative('setPageTitle', { title });
    // if (tools.versionCompare(env.appVersion, '3.6.0') < 0) {
    //   return browserCallNative.callNative('setPageTitle', { title });
    // } else {
    //   return callNative('NavBar', 'setPageTitle', { tilte });
    // }
  }

  // static goBack() {
  //   return browserCallNative.callNative('goBack', {});
  // }

  static call(params) {
    if (env.isIOS && tools.versionCompare(env.appVersion, '3.1.3') < 0) {
      return Promise.resolve();
    }
    return callNative('SystemUtil', 'call', params);
  }

  static getCityInfo() {
    return callNative('SystemUtil', 'getCityInfo')
      .then((data) => ({
        citycode: data.cityCode,
        cityCode: data.cityCode,
        adcode: data.adCode,
        adCode: data.adCode,
        city: data.cityName,
        latitude: data.lat,
        longitude: data.lng,
      }));
  }

  static getRideHistory(params) {
    if (tools.versionCompare(env.appVersion, '3.1.2') < 0) {
      return browserCallNative.callNative('getRideHistory', params);
    }
    const paramsCopy = params;
    delete paramsCopy.start;
    return callNative('Business', 'getRideHistory', paramsCopy);
  }

  static chargeVip(params) {
    return callNative('Business', 'buyVip', params);
  }

  static setShareInfo(params) {
    return callNative('Business', 'setShareInfo', params);
  }

  static getCurCityBikeType() {
    return callNative('Business', 'getCurCityBikeType');
  }

  static getCurrentLocation() {
    return callNative('SystemUtil', 'getCurrentLocation');
  }

  static callNative(classMap, method, params) {
    if (Object.prototype.hasOwnProperty.call(this, method)) {
      return this[method](params);
    }
    return callNative(classMap, method, params);
  }

  static savePicture(params) {
    callNative('SystemUtil', 'savePicture', params);
    return Promise.resolve();
  }

  static callphotograph(params) {
    return callNative('Business', 'hitchTakePhotos', params);
  }

  /**
  * 顺风车通过APP调用系统拍照及相册
  * @param Array {sourceType: [] } 默认 ['camera','album']
  * @description 5.37.0版本提供
  */
  static hitchCallCameraAndAlbum(params) {
    return callNative('business/hitch', 'hitchCallCameraAndAlbum', params);
  }

  /**
   * 调用APPd的OCR能力
   */
  static hitchGetOCRResult(params) {
    return callNative(env.isIOS ? 'Business' : 'business/hitch', 'hitchGetOCRResult', params);
  }

  /**
   *
   */
  static hitchSetWorkPath(params) {
    return callNative(env.isIOS ? 'Business' : 'business/hitch', 'hitchSetWorkPath', params);
  }


  /**
   * 跳转实名认证
   */
  static gotoUserCertification(params) {
    return callNative('business/hitch', 'gotoUserCertification', params);
  }

  static getSSID() {
    return callNative('SystemUtil', 'getSSID');
  }

  /**
    * 友盟埋点
    * 友盟地址: https://developer.umeng.com/docs/67964/detail/71107#h3-u81EAu5B9Au4E49u4E8Bu4EF6
    * @param {Object} obj
    * @param {String} obj.event 事件id,必传
    * @param {Object<attribute>} obj.attribute 友盟需要的辅助参数
  */
  static sendEventLog(params) {
    return callNative('Business', 'sendEventLog', params);
  }

  static getTaxiCreditRideGrantCode() {
    return callNative(env.isIOS ? 'Business' : 'business/taxi', 'getTaxiCreditRideGrantCode');
  }

  static openFaceLiveness(params) {
    return callNative(env.isIOS ? 'Business' : 'business/hitch', 'openFaceLiveness', params);
  }

  /**
   * 链接跳转
   * @param {string} url 跳转链接
   */
  static navigateTo(url) {
    window.location.href = url;
  }

  /**
   * 跳转支付宝实名认证
   */
  static gotoUserAliPayCertification(params) {
    return callNative('business/hitch', 'gotoUserAliPayCertification', params);
  }

  /**
   * 唤起支付宝去签署顺风车免密支付
   */
  static hitchOpenAliPayResult(params) {
    return callNative('business/hitch', 'hitchOpenAliPayResult', params);
  }

  /**
   * toast提示
   */
  static hitchToast(params) {
    return callNative('business/hitch', 'hitchToast', params);
  }

  /**
   * 打开微信服务通知
   */
  static openWechatNotice(params) {
    return callNative('business/hitch', 'openWechatNotice', params);
  }

  /**
   * 获取是否展示红点
   */
  static getCreditRedDotShow(params) {
    return callNative('business/hitch', 'getCreditRedDotShow', params);
  }

  /**
   * 点击更新红点
   */
  static updateCreditUpdateTime(params) {
    return callNative('business/hitch', 'updateCreditUpdateTime', params);
  }

  /**
   * 新开一个webview展示H5
   * 顺风车提供
   */
  static openHitchWebview(params) {
    return callNative('business/hitch', 'openHitchWebview', params);
  }

  /**
   * 存储数据到app缓存
   */
  static setStorage(params) {
    return callNative('business/hitch', 'setStorage', params);
  }

  /**
   * 从app获取缓存数据
   */
  static getStorage(params) {
    return callNative('business/hitch', 'getStorage', params);
  }

  /**
   * 获取客户端已安装的地图导航软件
   */
  static getInstalledMapApps(params) {
    return callNative('business/hitch', 'getInstalledMapApps', params);
  }

  /**
   * 获取是否展示司南调研icon
   */
  static showGuideLIneIcon(params) {
    return callNative('business/hitch', 'showGuideLIneIcon', params);
  }

  /**
   * 获取是否展示司南调研icon
   */
  static openGuideLIneModal(params) {
    return callNative('business/hitch', 'openGuideLIneModal', params);
  }

  // 支付
  static arousePayDeskModule(params) {
    return callNative('allpay', 'arousePayDeskModule', params);
  }

  // 刷新页面
  static refreshDriverHome(params) {
    return callNative('business/hitch', 'refreshDriverHome', params);
  }

  /**
   * 获取设备指纹hash
   */
  static getDeviceFingerprintHash(params) {
    return callNative('SystemUtil', 'getDeviceFingerprintHash', params);
  }

  /**
   * 退出登录
   */
  static logout(params) {
    return callNative('business/user', 'logout', params);
  }

  /**
   * 显示loading
   * @param {loadingUrl: string} loadingUrl loading图片地址
   */
  static showLoading(params) {
    if (tools.versionCompare(env.appVersion, '5.72.0') >= 0) {
      return callNative('Business', 'showNativeLoading', params);
    }
    return browserCallNative.callNative('showLoading');
  }

  /**
   * 隐藏loading
   * @param {delayTime: longint} delayTime 延迟隐藏毫秒数
   */
  static hideLoading(params) {
    if (tools.versionCompare(env.appVersion, '5.72.0') >= 0) {
      return callNative('Business', 'dismissNativeLoading', params);
    }
    return browserCallNative.callNative('hideLoading', params);
  }

  static linkToNativeSystem(params) {
    return callNative('business/hitch', 'hitchJourneyRuleHandle', params);
  }

  static useNativeNavigationComponent(params = {}) {
    return callNative('business/hitch', 'useNativeNavigationComponent', params);
  }

  static openRecordStatusDetailPage(params = {}) {
    return callNative('safeCenter', 'openRecordStatusDetailPage', params);
  }

  static hitchDriverPreCheckOrder(params) {
    return callNative('business/hitch', 'hitchDriverPreCheckOrder', params);
  }

  static hitchDriverFastRemindPassenger(params) {
    return callNative('business/hitch', 'hitchDriverFastRemindPassenger', params);
  }

  static platformOpenUrl(params) {
    return callNative('ui', 'platformOpenUrl', params);
  }

  static closeCancelReasonPageAndNavigateToChatVC(params) {
    return callNative('business/hitch', 'closeCancelReasonPageAndNavigateToChatVC', params);
  }

  /**
   * 从相机拍照
   */
  static takePhotoFromCamera(params) {
    return callNative('business/hitch', 'takePhotoFromCamera', params);
  }

  /**
     * 从相册选择照片
     */
  static pickPhotoFromGallery(params) {
    return callNative('business/hitch', 'pickPhotoFromGallery', params);
  }

  static async chooseImageAndUploadImage(Params) {
    let beforeUpload;
    let afterUpload;
    if (Params) {
      ({
        beforeUpload,
        afterUpload,
      } = Params);
    }
    let relFile = '';
    if (Params && Params.usePickPhotoFromGallery) {
      relFile = await this.pickPhotoFromGallery();
      // console.error(relFile.imageBase64String.replace(/data:image\/.*;base64,/, ''));
    } else {
      // app使用hitchCallCameraAndAlbum打开相机和相册
      // 不使用callphotograph是因为该方法是针对车主认证拍摄身份证 & 图片用
      relFile = await this.hitchCallCameraAndAlbum({ sourceType: ['camera', 'album'] }) || {};
    }
    // // app使用hitchCallCameraAndAlbum打开相机和相册
    // // 不使用callphotograph是因为该方法是针对车主认证拍摄身份证 & 图片用
    // relFile = await this.hitchCallCameraAndAlbum({ sourceType: ['camera', 'album'] }) || {};


    // console.warn('app 选择照片回调', relFile);
    if (beforeUpload) {
      beforeUpload();
    }

    try {
      const imageUrl = await platformApi.uploadImage({
        file: relFile.photoStr || (relFile && relFile.imageBase64String && relFile.imageBase64String.replace(/data:image\/.*;base64,/, '')) || '',
        image: 40,
        type: env.isAndroid ? PLATFORM_TYPE.APP_ANDROID : PLATFORM_TYPE.APP_IOS,
      });
      if (afterUpload) {
        afterUpload();
      }
      return imageUrl.url;
    } catch (error) {
      if (afterUpload) {
        afterUpload();
      }
      return '';
    }
  }

  /**
   * 存储数据到app缓存
   */
  static setSpValue(params) {
    // eslint-disable-next-line no-console
    console.warn('调用app setSpValue', params);
    return callNative('business/hitch', 'setSpValue', params);
  }

  /**
   * 打开抖音app
   */
  static jump2DouYinHitchDriverProfile(params) {
    return callNative('business/hitch', 'jump2DouYinHitchDriverProfile', params);
  }


  /**
   * 车主app添加主屏幕
   */
  static createShortcutToDesktop(params) {
    return callNative('business/hitch', 'createShortcutToDesktop', params);
  }

  static jumpToPreOrderDetailPage(url) {
    return callNative('business/hitch', 'jumpToPreOrderDetailPage', url);
  }
}
